import map from '../assets/wave_energy_resource_map.png'
import wavemill_home from '../assets/wavemill_home.jpg'

export default function Home() {
  return (
  <div className="container">   
    <div className="page">
    <section>
      <h2 className="align_center">      
        We develop  Wave Mill technology to harness ocean wave energy
      </h2>
    </section>    
   
      <p className='align_left'>
        Unlike solar or wind energy, the ocean delivers wave energy 24/7. Waves get their energy from wind, and wind is driven by solar energy. 
        Waves gather, store, and transmit this energy over thousands of miles with little loss. <br />
        <br />
        As long as the sun shines, wave energy will never be depleted. It varies in intensity, but it is available twenty-four hours a day, 365 days a year. <br />
        <br />
        The map shows the annual average wave power in kilowatts per metre of crest width for various sites around the world. 
        <a href="http://www.renewablegreenenergypower.com/what-is-wave-energy/" target="_blank" rel="noreferrer"> Read more about the world wave energy resource </a>
      </p> 
 
    <img className='center' src={map} alt='' />
	   <br />
      <br />
  
      <p className='align_left'>
        The world's electricity consumption is approximately 26,000 TWh per year.  
        The theoretical potential of wave energy is estimated to be 30,000 TWh. <br />
        <br />
        Most wave energy resources are found between 30° and 60° latitude in deep-water locations. 
        The northern and southern temperate zones have the best sites for capturing wave power.  <br />
        <br />
        The United States' estimated wave energy potential is 1,200 TWh, or almost 35% of the country's electricity consumption.  
        The Alaska coastline accounts for approximately 50% of this total.  <br />

        <br />  <br />    
        We develop Wave Mill technology - an ocean wave energy converter designed to operate quietly and without moving mechanical parts.<br /> 
        Its open deck design allows for a wide range of customer applications. <br />
      </p> 

      <img src={wavemill_home} alt='' />    
      <br />
      The Wave Mill unit in the Moreton Bay
        
   </div>
  </div>
  );
};
